import { combineReducers } from "redux";
import auth from "./reducers/auth";
import role from "./reducers/role";
import quiz from "./reducers/quiz";
import chart from "./reducers/chart";

const appReducer = combineReducers({
  auth,
  role,
  quiz,
  chart,
});

// reset the state of a redux store
const rootReducer = (state, action) => {
  if (action.type === "CLEAR_STATE") {
    state = undefined;
    localStorage.clear();
  }
  return appReducer(state, action);
};

export default rootReducer;
